// Espace organisateur : réservé au staff et aux administrateurs (les droits sont de toute façon
// vérifiés par Supabase pour chaque action).

import { t } from '@shared/i18n';
import { useEffect, useState } from 'react';
import { Navigate, NavLink, Outlet } from 'react-router-dom';
import { listProfiles } from '../api';
import { isPendingMember } from '@shared/types';
import { useAuth } from '../auth';

export function AdminLayout() {
  const { session, profile, loading, isStaff, signOut } = useAuth();
  const [pending, setPending] = useState(0);

  useEffect(() => {
    if (!isStaff) return;
    listProfiles()
      .then((p) => setPending(p.filter(isPendingMember).length))
      .catch(() => {});
  }, [isStaff]);

  if (loading)
    return (
      <p className="container muted" style={{ paddingTop: 40 }}>
        {t('Chargement…', 'Loading…')}
      </p>
    );
  if (!session) return <Navigate to="/organisateur/connexion" replace />;
  if (!isStaff) {
    return (
      <div className="container narrow" style={{ paddingTop: 40 }}>
        <div className="card stack">
          <h2 style={{ marginTop: 0 }}>{t('Accès réservé aux organisateurs', 'Organisers only')}</h2>
          <p className="muted" style={{ margin: 0 }}>
            {t(
              `Ton compte (${profile?.display_name || session.user.email}) n'a pas le rôle staff ou administrateur.`,
              `Your account (${profile?.display_name || session.user.email}) does not have the staff or administrator role.`,
            )}
          </p>
          <div>
            <button className="btn secondary" onClick={signOut}>
              {t('Se déconnecter', 'Sign out')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container admin">
      <nav className="admin-nav">
        <NavLink to="/organisateur" end>
          {t('Tableau de bord', 'Dashboard')}
        </NavLink>
        <NavLink to="/organisateur/membres">
          {t('Membres', 'Members')} {pending > 0 && <span className="pill">{pending}</span>}
        </NavLink>
        <NavLink to="/organisateur/evenements">{t('Événements', 'Events')}</NavLink>
        <NavLink to="/organisateur/traces">{t('Tracés', 'Routes')}</NavLink>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            signOut();
          }}
          className="muted"
        >
          {t('Se déconnecter', 'Sign out')}
        </a>
      </nav>
      <section>
        <Outlet context={{ refreshPending: setPending }} />
      </section>
    </div>
  );
}
